// Presentation only: quantity, price and tax calculation values remain untouched.
export const formatVatRate = value => {
  if (value == null || value === '') return '—';
  const number = Number(String(value).trim().replace(/%$/, '').replace(',', '.'));
  if (number === 0) return '0';
  return Number.isFinite(number)
    ? number.toLocaleString('nl-BE', { useGrouping: false, maximumFractionDigits: 20 })
    : '—';
};

export const vatLabel = value => {
  const rate = formatVatRate(value);
  return rate === '—' ? rate : `${rate}%`;
};